module.exports = {
  author: "Oleksandr Bilyi",
  siteTitle: "starting-help.com.ua - Благодійний фонд СТАРТІНГ ХЕЛП",
  shortSiteTitle: "Благодійний фонд СТАРТІНГ ХЕЛП, Допомагаємо діткам,які знаходяться в дитячому будинки і дітям, які вимушено покинули свої будинки внаслідок війни", // <title> ending for posts and pages
  siteDescription: "Благодійний фонд СТАРТІНГ ХЕЛП, Допомагаємо діткам,які знаходяться в дитячому будинки і дітям, які вимушено покинули свої будинки внаслідок війни, людям похилого віку, які знаходяться в пансіонаті, допомагаємо адресно людям, які надають запити",
  siteUrl: "https://starting-help.com.ua",
  siteLanguage: "ua",

  /* author */
  authorEmail: "<o.d.bilyi@gmail.com>",
  authorName: "Oleksandr Bilyi",

  /* manifest.json */
  manifestName: "СТАРТІНГ ХЕЛП",
  manifestShortName: "Благодійний фонд", // max 12 characters
  manifestStartUrl: "/index.html",
  manifestBackgroundColor: "white",
  manifestThemeColor: "#666",
  manifestDisplay: "standalone",
  gravatarImgMd5: "",

  supportPhone: '+38068',
  supportEmail: 'test@gmail.com',
  workTime: '24/7',
  address: 'м. Чернівці',
  charterOfCharitableOrganization: 'https://youcontrol.com.ua/catalog/company_details/44855729/',
  noteInTheStateRegister: 'https://youcontrol.com.ua/catalog/company_details/44855729/',
  socialLinks: {
    instagram: 'https://www.instagram.com/starting_help/?fs=e&s=cl',
    facebook: 'https://www.facebook.com/104121188974796/posts/pfbid0HTzr4GWRQJb1ipPu7XXrQDcR25x475aatAn2Fc9h1fFv7bfWsrMUa2HFe7cx3hyFl/?d=n',
  }
}